import { withInstall } from '@ll-plus/utils'

import ConfigProvider from './src/config-provider.vue'

export const LlConfigProvider = withInstall(ConfigProvider)
export default LlConfigProvider
export * from './src/config-provider'
export * from './src/hooks'

declare module 'vue' {
  export interface GlobalComponents {
    LlConfigProvider: typeof ConfigProvider
  }
}
